export default __webpack_public_path__ + "static/media/0xe95fd76cf16008c12ff3b3a937cb16cd9cc20284.ee115595.webp";